import * as React from "react";

function SvgLoginWallpaper(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={379.919}
      height={262.269}
      {...props}
    >
      <defs>
        <linearGradient
          id="LoginWallpaper_svg__a"
          y1={0.5}
          x2={1}
          y2={0.5}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="gray" stopOpacity={0.251} />
          <stop offset={0.54} stopColor="gray" stopOpacity={0.122} />
          <stop offset={1} stopColor="gray" stopOpacity={0.102} />
        </linearGradient>
      </defs>
      <g data-name="Group 10917">
        <path
          data-name="Path 43244"
          d="M214.89 35.711c-24.352.033-47.792-6.871-70.213-14.54S100.009 4.914 76.11 1.271C60.74-1.068 43.261-.853 31.246 7.64c-11.565 8.171-14.914 21.694-16.53 34.188-1.215 9.4-1.776 19.264 2.776 27.861 3.16 5.968 8.568 10.888 12.38 16.576 13.3 19.788 5.3 45.065-7.627 65.313-6.063 9.5-13.165 18.605-17.749 28.649s-6.464 21.433-1.789 31.347c4.633 9.826 15.1 16.957 26.326 21.827 22.8 9.91 49.356 12.034 75.194 12.852 57.194 1.815 114.5-1.886 171.652-5.587 21.15-1.368 42.394-2.746 63.107-6.711 11.5-2.2 23.342-5.463 31.5-12.618 10.35-9.083 12.468-23.912 4.936-34.572-12.631-17.879-45.935-21.251-54.992-40.6-4.994-10.65-.687-22.863 5.656-33.129 13.6-22.026 37.022-41.756 37.416-66.391.27-16.918-11.907-33.422-30.1-40.775-19.065-7.7-45.059-5.721-58.416 8.633C261.255 29.3 236.39 35.688 214.89 35.711z"
          fill="#859fc3"
          opacity={0.1}
        />
        <path
          data-name="Path 43245"
          d="M323.349 210.249s-4-2.642-7.972-.762c0 0 1.222 2.352 6.245 2.131z"
          fill="#6c63ff"
        />
        <path
          data-name="Path 43246"
          d="M323.858 210.389s1.218 4.639-1.837 7.8c0 0-1.838-1.912 0-6.6z"
          fill="#6c63ff"
        />
        <path
          data-name="Path 43247"
          d="M328.835 205.935s-.3-3.945-9.207-2.636c0 0-.043 2.544 3.085 3.75s4.561.189 6.122-1.114z"
          fill="#6c63ff"
        />
        <path
          data-name="Path 43248"
          d="M329.396 205.91s3.766 1.209.407 9.565c0 0-2.486-.554-2.932-3.88s.876-4.473 2.525-5.685z"
          fill="#6c63ff"
        />
        <path
          data-name="Path 43249"
          d="M334.425 200.312s.511-6.493-8.594-5.828c0 0-.652 5.864 6.988 7.389z"
          fill="#6c63ff"
        />
        <g data-name="Group 10918" fill="#7f9fc6">
          <path
            data-name="Path 43250"
            d="M340.443 192.982s-1.248-7.359-10.35-5.167c0 0-.033 6.362 8.864 6.92z"
          />
          <path
            data-name="Path 43251"
            d="M344.841 185.405s-2.092-7.167-11.109-5.024c0 0 2.147 6.447 10.51 6.346z"
          />
          <path
            data-name="Path 43252"
            d="M349.017 178.003s-2.043-7.437-10.751-5.212c0 0 2.906 7.066 10.174 6.47z"
          />
          <path
            data-name="Path 43253"
            d="M351.708 170.973s-1.57-9.1-9.689-7.083c0 0 2.358 8.275 9.093 8.408z"
          />
          <path
            data-name="Path 43254"
            d="M354.233 162.479s-1.886-9.168-10.1-6.516c0 0 3.219 8.666 9.516 7.77z"
          />
          <path
            data-name="Path 43255"
            d="M355.784 154.576s-2.994-9.171-9.343-8.923c0 0 3.059 9.686 8.812 10.751z"
          />
          <path
            data-name="Path 43256"
            d="M356.788 146.862s-3.258-11.038-8.425-10.187c0 0 2.254 8.438 8.242 11.907z"
          />
          <path
            data-name="Path 43257"
            d="M357.355 137.654s-3.056-9.2-8.145-9.565c0 0 2.078 9.05 8.044 11.956z"
          />
          <path
            data-name="Path 43258"
            d="M357.97 129.071s-3.808-9.207-7.167-9.415c0 0 1.655 9.067 6.841 10.927z"
          />
          <path
            data-name="Path 43259"
            d="M358.39 121.082s-2.343-10-5.708-10.829c0 0 .459 8.18 5.369 11.578z"
          />
          <path
            data-name="Path 43260"
            d="M359.661 110.618s-2.463-7.972-5.189-9.187c0 0 .537 9.4 4.561 11.135z"
          />
          <path
            data-name="Path 43261"
            d="M360.713 103.777l.5-14.054s-5.1 10.595-.863 16.52z"
          />
          <path
            data-name="Path 43262"
            d="M364.644 89.798s3.672-10.262 4.561-10.836c0 0-7.2 6.659-6.5 15.224z"
          />
          <path
            data-name="Path 43263"
            d="M334.674 200.264s6.457-.844 6.265 8.282c0 0-5.835.951-7.74-6.6z"
          />
          <path
            data-name="Path 43264"
            d="M340.749 192.735s7.46-.023 6.841 9.317c0 0-6.265 1.121-8.33-7.552z"
          />
          <path
            data-name="Path 43265"
            d="M344.914 186.008s6.773-3.176 11.106 5.023c0 0-6.255 2.645-11.705-3.7z"
          />
          <path
            data-name="Path 43266"
            d="M349.165 178.072s6.936-3.378 11.008 4.629c0 0-7.226 2.489-11.582-3.362z"
          />
          <path
            data-name="Path 43267"
            d="M351.62 171.171s6.675-6.376 12 .072c0 0-6.819 5.248-12.308 1.349z"
          />
          <path
            data-name="Path 43268"
            d="M353.855 162.261s6.714-6.516 12 .3c0 0-7.535 5.353-12.24 1.069z"
          />
          <path
            data-name="Path 43269"
            d="M355.11 154.316s5.173-8.145 11.266-6.327c0 0-5.369 8.624-11.207 8.239z"
          />
          <path
            data-name="Path 43270"
            d="M356.634 146.81s5.213-10.256 10.145-8.47c0 0-3.759 7.884-10.278 10.2z"
          />
          <path
            data-name="Path 43271"
            d="M356.996 137.125s5.359-8.073 10.379-7.086c0 0-4.382 8.187-10.9 9.422z"
          />
          <path
            data-name="Path 43272"
            d="M357.412 128.892s4.154-9.06 7.529-9.122c0 0-1.994 8.995-7.249 10.66z"
          />
          <path
            data-name="Path 43273"
            d="M358.228 120.888s4.616-9.174 8.086-9.194c0 0-2.362 7.845-7.933 10z"
          />
          <path
            data-name="Path 43274"
            d="M358.921 111.193s3.453-7.591 6.313-8.451c0 0-1.726 9.252-5.932 10.464z"
          />
          <path
            data-name="Path 43275"
            d="M361.123 103.5l7.718-11.757s-1.978 11.6-8.845 14.009z"
          />
          <path
            data-name="Path 43276"
            d="M366.421 90.746s8.969-6.19 9.294-7.19c0 0-4.561 8.669-13.031 10.2z"
          />
          <path
            data-name="Path 43277"
            d="M366.959 87.96s10.3-9.9 12.927-9.891a16.811 16.811 0 00-13.175 9.363z"
          />
          <path
            data-name="Path 43278"
            d="M359.023 112.661l.375.049c1.935-15.146 4.756-24.108 7.942-25.206l-.124-.358c-3.378 1.173-6.219 9.998-8.193 25.515z"
          />
          <path
            data-name="Path 43279"
            d="M356.175 148.881l.567.046c.12-1.414.212-2.86.273-4.3.541-12.536 1.378-24.049 2.479-32.679l-.326-.407c-1.1 8.649-2.18 20.508-2.72 33.064a101.526 101.526 0 01-.273 4.276z"
          />
          <path
            data-name="Path 43280"
            d="M312.78 217.471c.1-.042 10.076-4.5 20.433-15.126a82.171 82.171 0 0014.937-21.176c4.789-9.751 7.708-21.733 8.685-33.373l-.59.277c-2.2 26.128-14.093 43.981-23.551 53.705-10.256 10.532-20.124 14.944-20.221 14.986z"
          />
        </g>
        <path
          data-name="Path 43281"
          d="M338.622 27.768H25.581a2.789 2.789 0 00-2.789 2.789v8.121h318.615v-8.125a2.789 2.789 0 00-2.785-2.785z"
          fill="#0b5a81"
        />
        <path
          data-name="Path 43282"
          d="M22.792 38.682v182.842a5.623 5.623 0 005.623 5.623h307.369a5.623 5.623 0 005.623-5.623V38.682z"
          fill="#fff"
        />
        <circle
          data-name="Ellipse 696"
          cx={1.303}
          cy={1.303}
          transform="translate(26.535 31.841)"
          fill="#fa5959"
          opacity={0.8}
          r={1.303}
        />
        <circle
          data-name="Ellipse 697"
          cx={1.303}
          cy={1.303}
          transform="translate(30.119 31.841)"
          fill="#fed253"
          opacity={0.8}
          r={1.303}
        />
        <circle
          data-name="Ellipse 698"
          cx={1.303}
          cy={1.303}
          transform="translate(33.702 31.841)"
          fill="#8ccf4d"
          opacity={0.8}
          r={1.303}
        />
        <path
          data-name="Rectangle 3606"
          opacity={0.05}
          d="M52.409 69.169h256.065v112.597H52.409z"
        />
        <path
          data-name="Rectangle 3607"
          fill="#cee4f2"
          d="M54.363 70.022h252.156v110.115H54.363z"
        />
        <path
          data-name="Path 43283"
          d="M123.103 98.362a25.085 25.085 0 1025.085 25.085 25.085 25.085 0 00-25.085-25.085zm4.5 25.688v11.878h-8.865V124.05a7.346 7.346 0 118.868 0z"
          fill="#6c63ff"
        />
        <path
          data-name="Path 43284"
          d="M123.103 98.362a25.085 25.085 0 1025.085 25.085 25.085 25.085 0 00-25.085-25.085zm4.5 25.688v11.878h-8.865V124.05a7.346 7.346 0 118.868 0z"
          fill="#eff5fa"
        />
        <path
          data-name="Path 43285"
          d="M123.104 91.195a32.253 32.253 0 1032.253 32.252 32.252 32.252 0 00-32.253-32.252zm5.783 33.028v15.269h-11.4v-15.269a9.448 9.448 0 1111.4 0z"
          fill="#7f9fc6"
        />
        <path
          data-name="Rectangle 3608"
          fill="#fff"
          d="M168.713 119.216h104.25v11.077h-104.25z"
        />
        <path
          data-name="Rectangle 3609"
          fill="#ff9800"
          d="M251.139 134.175h22.479v11.077h-22.479z"
        />
        <path
          data-name="Path 43286"
          d="M178.971 124.587h-1.886l1.678-1.675a.166.166 0 000-.231.163.163 0 00-.231 0l-1.678 1.678v-1.89a.163.163 0 00-.163-.163.166.166 0 00-.163.163v1.89l-1.675-1.688a.163.163 0 00-.231 0 .166.166 0 000 .231l1.678 1.675h-1.89a.166.166 0 00-.163.163.163.163 0 00.163.163h1.89l-1.678 1.678a.166.166 0 000 .231.169.169 0 00.231 0l1.675-1.678v1.886a.163.163 0 10.326 0v-1.886l1.678 1.678a.169.169 0 00.231 0 .166.166 0 000-.231l-1.678-1.678h1.886a.158.158 0 100-.316z"
          fill="#6c63ff"
        />
        <path
          data-name="Path 43287"
          d="M185.813 124.587h-1.886l1.678-1.675a.166.166 0 000-.231.163.163 0 00-.231 0l-1.678 1.678v-1.89a.163.163 0 00-.163-.163.166.166 0 00-.163.163v1.89l-1.674-1.688a.163.163 0 00-.231 0 .166.166 0 000 .231l1.678 1.675h-1.89a.166.166 0 00-.163.163.163.163 0 00.163.163h1.89l-1.678 1.678a.166.166 0 000 .231.169.169 0 00.231 0l1.674-1.678v1.886a.163.163 0 00.326 0v-1.886l1.678 1.678a.169.169 0 00.231 0 .166.166 0 000-.231l-1.678-1.678h1.886a.158.158 0 100-.316z"
          fill="#6c63ff"
        />
        <path
          data-name="Path 43288"
          d="M192.654 124.587h-1.886l1.678-1.675a.166.166 0 000-.231.163.163 0 00-.231 0l-1.678 1.678v-1.89a.163.163 0 00-.163-.163.166.166 0 00-.163.163v1.89l-1.675-1.688a.163.163 0 00-.231 0 .166.166 0 000 .231l1.678 1.675h-1.89a.166.166 0 00-.163.163.163.163 0 00.163.163h1.89l-1.678 1.678a.166.166 0 000 .231.169.169 0 00.231 0l1.675-1.678v1.886a.163.163 0 10.326 0v-1.886l1.678 1.678a.17.17 0 00.231 0 .166.166 0 000-.231l-1.678-1.678h1.886a.158.158 0 100-.316z"
          fill="#6c63ff"
        />
        <path
          data-name="Path 43289"
          d="M199.496 124.587h-1.886l1.678-1.675a.166.166 0 000-.231.163.163 0 00-.231 0l-1.678 1.678v-1.89a.163.163 0 00-.163-.163.166.166 0 00-.163.163v1.89l-1.675-1.688a.163.163 0 00-.231 0 .166.166 0 000 .231l1.678 1.675h-1.89a.166.166 0 00-.163.163.163.163 0 00.163.163h1.89l-1.678 1.678a.166.166 0 000 .231.169.169 0 00.231 0l1.675-1.678v1.886a.163.163 0 10.326 0v-1.886l1.678 1.678a.169.169 0 00.231 0 .166.166 0 000-.231l-1.678-1.678h1.886a.158.158 0 100-.316z"
          fill="#6c63ff"
        />
        <path
          data-name="Path 43290"
          d="M206.337 124.587h-1.886l1.678-1.675a.166.166 0 000-.231.163.163 0 00-.231 0l-1.678 1.678v-1.89a.163.163 0 00-.163-.163.166.166 0 00-.163.163v1.89l-1.674-1.688a.163.163 0 00-.231 0 .166.166 0 000 .231l1.678 1.675h-1.889a.166.166 0 00-.163.163.163.163 0 00.163.163h1.889l-1.678 1.678a.166.166 0 000 .231.17.17 0 00.231 0l1.674-1.678v1.886a.163.163 0 00.326 0v-1.886l1.678 1.678a.169.169 0 00.231 0 .166.166 0 000-.231l-1.678-1.678h1.886a.158.158 0 100-.316z"
          fill="#6c63ff"
        />
        <path
          data-name="Path 43291"
          d="M213.179 124.587h-1.886l1.678-1.675a.166.166 0 000-.231.163.163 0 00-.231 0l-1.678 1.678v-1.89a.163.163 0 00-.163-.163.166.166 0 00-.163.163v1.89l-1.675-1.688a.163.163 0 00-.231 0 .166.166 0 000 .231l1.678 1.675h-1.889a.166.166 0 00-.163.163.163.163 0 00.163.163h1.889l-1.678 1.678a.166.166 0 000 .231.169.169 0 00.231 0l1.675-1.678v1.886a.163.163 0 10.326 0v-1.886l1.678 1.678a.169.169 0 00.231 0 .166.166 0 000-.231l-1.678-1.678h1.886a.158.158 0 100-.316z"
          fill="#6c63ff"
        />
        <path
          data-name="Path 43292"
          d="M220.02 124.587h-1.886l1.678-1.675a.166.166 0 000-.231.163.163 0 00-.231 0l-1.678 1.678v-1.89a.163.163 0 00-.163-.163.166.166 0 00-.163.163v1.89l-1.675-1.688a.163.163 0 00-.231 0 .166.166 0 000 .231l1.678 1.675h-1.89a.166.166 0 00-.163.163.163.163 0 00.163.163h1.89l-1.678 1.678a.166.166 0 000 .231.169.169 0 00.231 0l1.675-1.678v1.886a.163.163 0 10.326 0v-1.886l1.678 1.678a.169.169 0 00.231 0 .166.166 0 000-.231l-1.678-1.678h1.886a.158.158 0 100-.316z"
          fill="#6c63ff"
        />
        <path
          data-name="Path 43293"
          d="M226.861 124.587h-1.886l1.678-1.675a.166.166 0 000-.231.163.163 0 00-.231 0l-1.678 1.678v-1.89a.163.163 0 00-.163-.163.166.166 0 00-.163.163v1.89l-1.674-1.688a.163.163 0 00-.232 0 .166.166 0 000 .231l1.678 1.675h-1.889a.166.166 0 00-.163.163.163.163 0 00.163.163h1.889l-1.678 1.678a.166.166 0 000 .231.17.17 0 00.232 0l1.674-1.678v1.886a.163.163 0 00.326 0v-1.886l1.678 1.678a.17.17 0 00.231 0 .166.166 0 000-.231l-1.678-1.678h1.886a.158.158 0 100-.316z"
          fill="#6c63ff"
        />
        <path
          data-name="Path 43294"
          d="M233.703 124.587h-1.886l1.678-1.675a.166.166 0 000-.231.163.163 0 00-.231 0l-1.678 1.678v-1.89a.163.163 0 00-.163-.163.166.166 0 00-.163.163v1.89l-1.675-1.688a.163.163 0 00-.231 0 .166.166 0 000 .231l1.678 1.675h-1.89a.166.166 0 00-.163.163.163.163 0 00.163.163h1.89l-1.678 1.678a.166.166 0 000 .231.169.169 0 00.231 0l1.675-1.678v1.886a.163.163 0 10.326 0v-1.886l1.678 1.678a.169.169 0 00.231 0 .166.166 0 000-.231l-1.678-1.678h1.886a.158.158 0 100-.316z"
          fill="#6c63ff"
        />
        <path
          data-name="Path 43295"
          d="M240.544 124.587h-1.886l1.678-1.675a.166.166 0 000-.231.163.163 0 00-.231 0l-1.678 1.678v-1.89a.163.163 0 00-.163-.163.166.166 0 00-.163.163v1.89l-1.675-1.688a.163.163 0 00-.231 0 .166.166 0 000 .231l1.678 1.675h-1.89a.166.166 0 00-.163.163.163.163 0 00.163.163h1.89l-1.678 1.678a.166.166 0 000 .231.169.169 0 00.231 0l1.675-1.678v1.886a.163.163 0 10.326 0v-1.886l1.678 1.678a.169.169 0 00.231 0 .166.166 0 000-.231l-1.678-1.678h1.886a.158.158 0 100-.316z"
          fill="#6c63ff"
        />
        <path
          data-name="Path 43296"
          d="M247.386 124.587H245.5l1.678-1.675a.166.166 0 000-.231.163.163 0 00-.231 0l-1.678 1.678v-1.89a.163.163 0 00-.163-.163.166.166 0 00-.163.163v1.89l-1.674-1.688a.163.163 0 00-.231 0 .166.166 0 000 .231l1.678 1.675h-1.889a.166.166 0 00-.163.163.163.163 0 00.163.163h1.889l-1.678 1.678a.166.166 0 000 .231.169.169 0 00.231 0l1.674-1.678v1.886a.163.163 0 00.326 0v-1.886l1.678 1.678a.169.169 0 00.231 0 .166.166 0 000-.231l-1.678-1.678h1.886a.158.158 0 100-.316z"
          fill="#6c63ff"
        />
        <path
          data-name="Path 43297"
          d="M834.907 494.777a5.824 5.824 0 00-.147-1.17c-.293-1.1-.955-2.434-2.043-2.766a17.162 17.162 0 01-3.238-1.368c-.2-3.492.606-7.066-.267-10.451a26.585 26.585 0 01-1.007-3.691c-.179-1.577.251-3.258-.378-4.711a4.649 4.649 0 00-2.753-2.378 14.668 14.668 0 00-3.671-.652c-1.564-.127-6.627-.726-8.392.671a1.837 1.837 0 00-.326.326 1.3 1.3 0 00-.1.169l-.016.026a1.3 1.3 0 00-.088.212 1.634 1.634 0 00-.055.244v.586c.023.293.065.586.065.876a1.892 1.892 0 01-.039.43 3.01 3.01 0 01-.541 1.056l-.059.085c-.036.052-.072.1-.1.153s-.059.091-.085.137-.052.075-.075.117a1.61 1.61 0 00-.085.166c0 .033-.036.062-.049.095a1.6 1.6 0 00-.1.274 1.818 1.818 0 00-.019.867 3.223 3.223 0 00.446 1.026c.081.134.169.264.261.394l.228.31a7.027 7.027 0 00-.068.912 6.74 6.74 0 002.573 5.3 19.963 19.963 0 01-.041 4.135c-.029.287-.065.577-.1.863s-.068.476-.108.713a3.305 3.305 0 01-1.423-.108 6.76 6.76 0 00-.652-.251c-.948-.238-1.915.707-2.854.42a.386.386 0 01-.042.13 1.278 1.278 0 00-.652-.192 2.377 2.377 0 01-1.414-.811l-1.241-1.17a1.37 1.37 0 01-.215-.241 1.679 1.679 0 01-.15-.4 4.618 4.618 0 00-1.2-1.723.814.814 0 00-.355-.257.55.55 0 00-.163 0 1.458 1.458 0 00-.107-.13 3.071 3.071 0 00-.27-.274c-.593-.547-.652-1.016-1.166-1.629a15.635 15.635 0 01-1.218-1.841c-.042-.342-.1-.694-.173-1.049a13.509 13.509 0 00-.713-2.378l-.652-1.443-.075.075c-.472-.7-.977-1.088-1.43-1-.759.156-1.134 1.629-1.013 3.554l.261 1.955a.6.6 0 00.036.147 3.614 3.614 0 00-.072.7c0 .274.254.476.388.72a2.036 2.036 0 01.326 1.111c-.016.14-.059.274-.065.411a1.581 1.581 0 00.306.847l1.629 2.737.326.573.02.026a1.391 1.391 0 00.436.5 5.969 5.969 0 00.538 1.978c.055.124.117.241.182.358a11.526 11.526 0 001.538 2l.775.87c.765.854 1.531 1.71 2.362 2.5a3.163 3.163 0 001.056.74 1.2 1.2 0 001.186-.173v1.212a.681.681 0 01.515 1.072 26.863 26.863 0 01-2.411 5.1 10.859 10.859 0 012.02 1.541 9.072 9.072 0 011.052 1.424c.029.241.052.479.065.717.241 3.883-1.261 7.737-2.606 11.438a8.914 8.914 0 00-.779 3.238 6.361 6.361 0 00-.73.524 4.831 4.831 0 01.134 2.065 3.663 3.663 0 01-.271 1.3 9.119 9.119 0 01-.469.837 12.433 12.433 0 00-1.2 4.958c-.1 1.026.3 2.28-.169 3.2a13.084 13.084 0 00-1.629 5.011 5.019 5.019 0 01-.15 1.17c-.1.326-.28.6-.371.922a3.942 3.942 0 00-.065 1.3 12.471 12.471 0 01-.684 4.6 6.25 6.25 0 00-.538 3.6 5.078 5.078 0 00-1.378 3.026 4.778 4.778 0 01-.1.863 4.2 4.2 0 01-.391.831 7.271 7.271 0 00-.886 3.909 10.877 10.877 0 00-1.756 4.587c-.29 1.626-.417 3.281-.788 4.887-.5 2.124-1.391 4.271-1.567 6.447a4.542 4.542 0 00-1.714 3.215 14.316 14.316 0 01-.753 3.672c-.267.593-.651 1.124-.906 1.73a7.949 7.949 0 00-.391 1.489 5.805 5.805 0 00-.1 2.443 3.682 3.682 0 01-.954.727c.052-.2.094-.4.13-.609-.841.762-2.365.5-3.036 1.411a1.375 1.375 0 00.326 1.886 2.6 2.6 0 00.674.29 10.778 10.778 0 004.978.769 1.488 1.488 0 00.564-.179 1.814 1.814 0 00.524-.606l.749-1.192a15.5 15.5 0 001.828.427c.062.521.108 1.042.13 1.564.326.065.762.085.915-.218a.793.793 0 00.055-.362c0-.231.033-.537.052-.85h.065a6.19 6.19 0 002.883-.583c-.349-2.886.8-5.708 1.8-8.438 1.052-2.873 1.955-5.8 2.864-8.724.652-2.059 1.372-4.053 2.01-6.115q1.205-3.909 2.421-7.819a83.554 83.554 0 011.111-3.421 53.3 53.3 0 013.02-6.721c.326-.616.651-1.225.919-1.863.326-.779.557-1.593.818-2.4a37.134 37.134 0 012.046-4.815c.023-.042.039-.082.062-.12.264 1.078.528 2.173.7 3.258a12.378 12.378 0 01.055 4.027 13.271 13.271 0 00-.417 2.73 16.848 16.848 0 001.065 3.658 13.928 13.928 0 01.365 2.8c.091 1.466.886 3.111.326 4.47-1.743 4.3-.9 9.164-1.893 13.683-.512 2.319-2.079 4.5-1.955 6.871q.13 2.525.443 5.037a4.794 4.794 0 00.407 1.528 5.633 5.633 0 00.446.73c-.143.055-.264.2-.368.511a2.01 2.01 0 00.723 2.281 3.173 3.173 0 00.942.326 4.961 4.961 0 001.362.189 3.215 3.215 0 00.427-.052 15.525 15.525 0 001.541.554 3.345 3.345 0 00.042.4.5.5 0 00.169.368.508.508 0 00.261.046h1.769v-.443a1.457 1.457 0 001.124-.365 1.74 1.74 0 00.326-.678q.723-2.453 1.437-4.91a15.7 15.7 0 00.7-5.6c-.629-6 .752-12.028.3-18.048a43.235 43.235 0 01.554-10.829c.147-.808.326-1.629.391-2.434.143-1.518-.033-3.053.075-4.561.036-.528.107-1.052.173-1.577a75.7 75.7 0 00.7-9.822 30.911 30.911 0 00-.2-3.258 1.861 1.861 0 00.889-.521 2.216 2.216 0 00.212-1.391 10.085 10.085 0 01.876-3.329 39.522 39.522 0 001.231-4.581 15.994 15.994 0 00.547-3.828q0-.2-.02-.391a1.01 1.01 0 00.3-.326 1.9 1.9 0 00.156-.6c.117-.831.238-1.665.355-2.5l.257-1.788 1.036-7.229c.088-.629.179-1.254.267-1.88l.27-1.87c.029-.222.062-.443.085-.652.781-1.325.022-3.097-.062-4.609zm-8.643 27.066a5.956 5.956 0 01-.651-2.831h-.036a1.453 1.453 0 00-.042-.919c-.1-.238-.277-.44-.384-.678a2.479 2.479 0 01-.176-.912 24.863 24.863 0 01.466-5.91c.042-.228.088-.459.13-.687a1.7 1.7 0 00.371-.29 2.64 2.64 0 00.42-.652c.368-.74.7-1.492 1.013-2.258.1-.248.248-.534.5-.6-.052 1.906.143 3.851-.632 5.571a3.524 3.524 0 00-.326.88c-.072.485.13.977.059 1.459-.036.251-.143.482-.186.73a.714.714 0 00.189.691.569.569 0 00.14.072c-.019.13-.036.264-.049.391-.026.267-.039.518-.055.674a21.034 21.034 0 00-.088 2.4c0 .863.033 1.727.02 2.606a1.77 1.77 0 01-.124.74 1.287 1.287 0 01-.248.326 8.437 8.437 0 00-.311-.803z"
          transform="translate(-535.069 -330.558)"
          fill="url(#LoginWallpaper_svg__a)"
        />
        <ellipse
          data-name="Ellipse 699"
          cx={1.837}
          cy={5.203}
          rx={1.837}
          ry={5.203}
          transform="rotate(-11.6 838.177 -1216.377)"
          fill="#fbbebe"
        />
        <path
          data-name="Path 43298"
          d="M280.658 258.198a1.972 1.972 0 00.723 2.258 3.218 3.218 0 00.935.326 4.93 4.93 0 001.359.186c.563-.026 1.1-.248 1.668-.326a.261.261 0 01.192.026.277.277 0 01.072.228 8.594 8.594 0 00.072.958.492.492 0 00.169.368.509.509 0 00.261.046h1.766a17.215 17.215 0 00-.5-4.607 1.031 1.031 0 00-.13-.326 1.08 1.08 0 00-.564-.326 3.15 3.15 0 00-1.365-.238 4 4 0 00-1.531.749 2.333 2.333 0 01-1.736.42c-.596-.156-1.088-.648-1.391.258z"
          fill="#3f3d56"
        />
        <path
          data-name="Path 43299"
          d="M254.733 256.767a4.889 4.889 0 01-1.782 1.212l-.3.143a.209.209 0 00-.1.082.175.175 0 00.033.147 2.107 2.107 0 002.391.87 1.266 1.266 0 00.525-.273 1.721 1.721 0 00.4-1.049 2.147 2.147 0 00-.049-1.2c-.45-1.023-.612-.556-1.118.068z"
          fill="#fbbebe"
        />
        <path
          data-name="Path 43300"
          d="M261.502 260.782a.793.793 0 01-.055.362c-.153.3-.58.283-.912.218a21.951 21.951 0 00-.4-3.29c-.632-.029-1.088.57-1.427 1.108l-.873 1.385a1.8 1.8 0 01-.521.606 1.538 1.538 0 01-.564.179 10.68 10.68 0 01-4.962-.769 2.629 2.629 0 01-.674-.287 1.378 1.378 0 01-.326-1.883c.674-.912 2.189-.652 3.03-1.407a7.591 7.591 0 01-.43 1.554c1.124-.169 1.88-1.2 2.786-1.886a1.713 1.713 0 01.795-.378 1.751 1.751 0 01.652.068 7.645 7.645 0 012.867 1.411 3.09 3.09 0 011.026 1.069 7.913 7.913 0 01-.012 1.94z"
          fill="#3f3d56"
        />
        <circle
          data-name="Ellipse 700"
          cx={6.731}
          cy={6.731}
          transform="translate(277.182 139.831)"
          fill="#fbbebe"
          r={6.731}
        />
        <path
          data-name="Path 43301"
          d="M297.172 186.301a15.963 15.963 0 01-.544 3.808 39.287 39.287 0 01-1.231 4.561 10.035 10.035 0 00-.87 3.323 2.21 2.21 0 01-.215 1.388 2.026 2.026 0 01-.951.544 1.19 1.19 0 00-.8.714 5.031 5.031 0 01-.677-1.492q-.877-2.684-1.629-5.4a.7.7 0 01.046-.652.815.815 0 01.283-.16 2.927 2.927 0 00.9-.58 1.322 1.322 0 00.3-.388 1.758 1.758 0 00.127-.736c0-.863 0-1.724-.023-2.587a21.6 21.6 0 01.091-2.388c0-.156.029-.407.055-.674.049-.511.146-1.1.424-1.3.414-.277 1.652.094 2.121.16.808.111 1.629.241 2.417.394a6.45 6.45 0 01.176 1.465z"
          fill="#3f3d56"
        />
        <path
          data-name="Path 43302"
          d="M269.996 154.097c-.26.521-.886.772-1.368 1.1l-1.652 1.134a1.1 1.1 0 01-.818.28 1.075 1.075 0 01-.609-.57.1.1 0 000-.026l-.342-.573-1.627-2.73a1.553 1.553 0 01-.3-.841c0-.14.049-.27.062-.411a1.97 1.97 0 00-.326-1.108c-.13-.244-.391-.446-.384-.72a2.6 2.6 0 01.182-1.052 2.131 2.131 0 01.713-.762c.153-.111.31-.215.473-.326a.933.933 0 01.283-.13c.271-.055.538.169.811.179 1.176.788 1.629 2.28 2.554 3.356.521.612.573 1.081 1.163 1.629.094.085.186.176.274.27a1.9 1.9 0 01.293.423c.102.282.752.611.618.878z"
          fill="#3f3d56"
        />
        <path
          data-name="Path 43303"
          d="M281.548 153.296a6.065 6.065 0 01.723 3.281 2.049 2.049 0 01-.283.863 2.79 2.79 0 01-2.31.893 1.362 1.362 0 00-1 .326.912.912 0 00.062 1.114 2.515 2.515 0 001 .652 8.825 8.825 0 004.291.951c.684-.065 1.349-.264 2.03-.365a21.306 21.306 0 012.235-.124c.886-.033 1.769-.121 2.652-.208l2.339-.231a.521.521 0 00.348-.127c.173-.2-.049-.5-.264-.652-1.241-.919-2.821-1.551-3.528-2.932a17.27 17.27 0 01-.668-2.131 17.894 17.894 0 01-.778-2.059 13.616 13.616 0 01-.108-1.9 2.543 2.543 0 00-.652-1.733 2.715 2.715 0 00-1.772-.57 5.737 5.737 0 00-4.32 1.4c-.3.3-.551.652-.857.919s-.723.345-.521.7.6.57.815.88a7.509 7.509 0 01.566 1.053z"
          fill="#fbbebe"
        />
        <path
          data-name="Path 43304"
          d="M294.817 162.773a37.007 37.007 0 01-1.994 7.34 27.64 27.64 0 00-1.173 3.29c-.251 1.01-.2 2.092-.433 3.1-.287 1.261-.573 2.525-.8 3.8a24.886 24.886 0 00-.463 5.9 2.465 2.465 0 00.176.909c.108.234.28.437.381.678a1.628 1.628 0 01-.091 1.3 3.773 3.773 0 01-.671 1.016c-3.036.906-6.284.609-9.448.8-2.916.176-5.864.775-8.737.277a6.926 6.926 0 01.684-3.939c1.352-3.691 2.847-7.536 2.606-11.4a11.782 11.782 0 00-.153-1.346 17.837 17.837 0 01.867-8.232 14.126 14.126 0 00.371-5.141 9.386 9.386 0 01-.023-1.684 2.962 2.962 0 01.612-1.574c0-.023.029-.046.046-.068a.447.447 0 01.244 0 .208.208 0 00.163 0l.036-.023a.081.081 0 01.094 0c.075.046.117.2.28.231a6.5 6.5 0 00.726.068 3.9 3.9 0 01.867.124h.039a2.545 2.545 0 001.264-.108 3.359 3.359 0 00.775-.3c.072-.078.521-.15.613-.205.3-.179.231-1.02.293-1.365a3.762 3.762 0 01.245-1.01 1.72 1.72 0 011.394-.811 7.434 7.434 0 011.671.15c1.215.173 2.46.143 3.652.424a2.721 2.721 0 001.8.078c.15.036.173.166.173.326a2.082 2.082 0 01-.091.446c-.209.9.5 1.727 1.15 2.378a3.691 3.691 0 00.961.766c.326.15.652.212.977.375a1.777 1.777 0 01.652.6 2.491 2.491 0 01.371.948 5.669 5.669 0 01-.106 1.882z"
          fill="#3f3d56"
        />
        <path
          data-name="Path 43305"
          d="M294.817 162.773a37.007 37.007 0 01-1.994 7.34 27.627 27.627 0 00-1.173 3.29c-.251 1.01-.2 2.092-.433 3.1-.287 1.261-.573 2.525-.8 3.8-.068.039-.14.075-.212.107a4.99 4.99 0 01-1.277.411 7.815 7.815 0 01-2.385-.078l-4.649-.622c-1.857-.251-3.835-.554-5.213-1.811a11.129 11.129 0 01-1.818-2.482 11.814 11.814 0 00-.153-1.345 17.833 17.833 0 01.867-8.233 14.131 14.131 0 00.371-5.141 9.391 9.391 0 01-.023-1.684 2.96 2.96 0 01.612-1.574 2.31 2.31 0 01.29-.065 1.439 1.439 0 01.2-.026h.094a1.418 1.418 0 01.326.039 5.878 5.878 0 01.652.251h.039a2.5 2.5 0 00.867.124c.43 0 .873-.068 1.3-.1a2.4 2.4 0 011.544.277 9.276 9.276 0 01.86.785 3.7 3.7 0 001.085.59 11.529 11.529 0 008.672-.182 1.7 1.7 0 01.87-.222 1.629 1.629 0 01.626.267c.2.114.388.225.586.326a2.491 2.491 0 01.371.948 5.665 5.665 0 01-.102 1.91z"
          opacity={0.1}
        />
        <path
          data-name="Path 43306"
          d="M297.654 160.616a17.384 17.384 0 01-3.714-1.629 1.662 1.662 0 00-.625-.267 1.748 1.748 0 00-.873.221 11.524 11.524 0 01-8.669.183 3.767 3.767 0 01-1.085-.59 9.767 9.767 0 00-.86-.785c-1.072-.694-2.554.12-3.753-.326a6.623 6.623 0 00-.652-.251c-.948-.238-1.912.707-2.844.42a15.847 15.847 0 00-.766 2.906 31.685 31.685 0 00-.212 3.427c0 .687-.033 1.375 0 2.062a.676.676 0 01.515 1.069 26.7 26.7 0 01-2.4 5.086 11.04 11.04 0 012.013 1.538c1.14 1.205 1.7 2.9 2.932 4.01 1.388 1.254 3.365 1.56 5.213 1.808l4.649.622a7.946 7.946 0 002.388.081 5.026 5.026 0 001.274-.414 2.28 2.28 0 00.71-.469 2.612 2.612 0 00.42-.652c.368-.736.7-1.489 1.013-2.251.107-.27.27-.586.563-.609 1.727-1.557 3.356-3.154 5.082-4.711a11.264 11.264 0 001.854-1.955c.857-1.267.078-3.062 0-4.594a5.8 5.8 0 00-.147-1.163c-.283-1.109-.941-2.438-2.026-2.767z"
          fill="#ff9800"
        />
        <path
          data-name="Path 43307"
          d="M269.996 154.097c-.261.521-.886.772-1.368 1.1l-1.652 1.134a1.1 1.1 0 01-.818.28 1.075 1.075 0 01-.609-.57v-.234a2.186 2.186 0 01.1-.779 2.428 2.428 0 01.73-.938 5.974 5.974 0 012.141-1.3.733.733 0 01.391-.039.52.52 0 01.143.062 1.889 1.889 0 01.293.424c.134.264.787.593.649.86z"
          opacity={0.1}
        />
        <path
          data-name="Path 43308"
          d="M273.885 157.531a2.373 2.373 0 01-1.411-.808l-1.235-1.147a1.156 1.156 0 01-.215-.241 1.69 1.69 0 01-.15-.4 4.6 4.6 0 00-1.2-1.72.781.781 0 00-.355-.254.714.714 0 00-.394.039 5.958 5.958 0 00-2.14 1.3 2.433 2.433 0 00-.73.938 2.168 2.168 0 00-.1.779 5.981 5.981 0 00.567 2.489c.055.12.117.241.182.358a11.277 11.277 0 001.531 1.99l.775.867c.762.853 1.525 1.707 2.352 2.492a3.105 3.105 0 001.056.736 1.179 1.179 0 001.212-.2 1.758 1.758 0 00.345-.619 12.191 12.191 0 001.007-4.063 15.3 15.3 0 00-.072-1.684c-.051-.585-.471-.816-1.025-.852z"
          fill="#ff9800"
        />
        <path
          data-name="Path 43309"
          d="M293.628 203.14a75.292 75.292 0 01-.7 9.8c-.065.524-.137 1.049-.173 1.573-.108 1.521.068 3.049-.075 4.561-.075.818-.244 1.629-.388 2.427a43.158 43.158 0 00-.554 10.8c.45 6-.928 12.011-.3 18a14.546 14.546 0 01-.192 3.483 14.763 14.763 0 01-.505 2.1q-.713 2.447-1.433 4.887a1.7 1.7 0 01-.326.678 1.544 1.544 0 01-1.222.362 14.093 14.093 0 01-5.356-1.662 1.864 1.864 0 01-.538-.326c-.355-.368-.326-.948-.482-1.433a13.628 13.628 0 00-.821-1.44 4.7 4.7 0 01-.355-1.482q-.326-2.5-.443-5.023c-.124-2.365 1.44-4.542 1.955-6.841.977-4.522.15-9.37 1.886-13.66.547-1.355-.248-3-.326-4.457a14.13 14.13 0 00-.365-2.8 17.335 17.335 0 01-1.062-3.649 13.4 13.4 0 01.414-2.72 12.233 12.233 0 00-.055-4.017c-.173-1.095-.437-2.189-.7-3.258l-.059.12a36.8 36.8 0 00-2.043 4.805c-.261.8-.489 1.613-.815 2.388-.267.652-.6 1.248-.919 1.86a53.4 53.4 0 00-3.013 6.695c-.4 1.127-.759 2.28-1.111 3.411l-2.414 7.819c-.652 2.056-1.365 4.043-2 6.1-.9 2.932-1.8 5.838-2.854 8.7-.977 2.72-2.141 5.538-1.792 8.412a6.192 6.192 0 01-2.877.583 16.853 16.853 0 01-4.887-1.186 3.8 3.8 0 01-1.688-1c-.723-.883-.544-2.176-.326-3.3a7.981 7.981 0 01.391-1.486c.248-.6.652-1.13.906-1.723a14.452 14.452 0 00.746-3.658 4.515 4.515 0 011.707-3.209c.179-2.17 1.072-4.31 1.564-6.431.371-1.606.5-3.258.788-4.887a10.733 10.733 0 011.749-4.577 7.256 7.256 0 01.886-3.909 4.279 4.279 0 00.388-.831 4.763 4.763 0 00.1-.86 5.086 5.086 0 011.375-3.02 6.129 6.129 0 01.534-3.583 12.449 12.449 0 00.684-4.584 4.016 4.016 0 01.062-1.3c.091-.326.27-.6.375-.915a5.211 5.211 0 00.147-1.17 13.522 13.522 0 011.629-5c.469-.919.072-2.167.169-3.19a12.33 12.33 0 011.2-4.942c.156-.28.326-.547.466-.837a3.624 3.624 0 00.27-1.3 4.8 4.8 0 00-.134-2.059 10.559 10.559 0 016.389-1.955 39.815 39.815 0 006.78-.375c.652-.147 1.3-.349 1.99-.446a12.882 12.882 0 014.685.479 5.579 5.579 0 00.652 2.825 30.323 30.323 0 012.414 11.637z"
          fill="#33313f"
        />
        <path
          data-name="Path 43310"
          d="M285.955 203.887l-3.743 8.418c-.173-1.095-.437-2.189-.7-3.258l-.058.121v-.171l2.039-4.486z"
          opacity={0.1}
        />
        <path
          data-name="Path 43311"
          d="M297.172 186.301a1.406 1.406 0 01-.743.277 3.613 3.613 0 01-1.219-.166l-2.932-.733a1.449 1.449 0 01-.267-.094c.049-.512.147-1.1.423-1.3.414-.277 1.652.094 2.121.16.808.111 1.629.241 2.417.394a6.445 6.445 0 01.2 1.466z"
          opacity={0.1}
        />
        <path
          data-name="Path 43312"
          d="M299.652 166.917c.062.27.15.538.2.811a6.188 6.188 0 01-.068 2.017l-.267 1.864-.267 1.873-1.032 7.21-.254 1.785-.358 2.492a1.784 1.784 0 01-.156.6 1.248 1.248 0 01-1.02.6 3.693 3.693 0 01-1.219-.166l-2.932-.736a.922.922 0 01-.358-.147.707.707 0 01-.189-.688c.042-.247.15-.479.186-.726.072-.482-.13-.977-.059-1.456a3.624 3.624 0 01.326-.876c.977-2.16.411-4.682.743-7.027a10.651 10.651 0 012.261-5.03 14.428 14.428 0 012.5-2.45 5.027 5.027 0 011.4-.977c.589-.123.465.616.563 1.027z"
          fill="#ff9800"
        />
        <path
          data-name="Path 43313"
          d="M277.463 138.853c-.215.684.121 1.437-.033 2.134-.166.769-.889 1.3-1.095 2.075-.326 1.176.671 2.248 1.4 3.225 2.7 3.629 2.349 8.653 1.424 13.08a67.54 67.54 0 01-3.078 10.425 7.989 7.989 0 01-1.658 2.909 8.575 8.575 0 014.594-.446c1.9.528 3.544 2.375 5.473 1.955 1.16-.257 1.974-1.287 3.017-1.857 1.955-1.052 4.31-.391 6.49-.052a2.548 2.548 0 001.417-.072 2.356 2.356 0 00.86-.792 8.035 8.035 0 001.675-4.333 5.559 5.559 0 00-1.6-4.278 9.148 9.148 0 01-1.372-1.3 4.046 4.046 0 01-.538-1.974c-.257-3.584.616-7.242-.283-10.708a26.442 26.442 0 01-1-3.681c-.179-1.574.248-3.258-.378-4.7a4.607 4.607 0 00-2.746-2.372 15.043 15.043 0 00-3.662-.652c-1.786-.149-8.161-.915-8.907 1.414z"
          fill="#33313f"
        />
        <g data-name="Group 10916" opacity={0.1}>
          <path
            data-name="Path 43314"
            d="M279.16 159.368a67.413 67.413 0 01-3.062 10.383c.225-.446.414-.915.593-1.381a67.186 67.186 0 003.079-10.425c.928-4.431 1.284-9.448-1.42-13.08-.652-.867-1.489-1.8-1.46-2.821a3.474 3.474 0 00-.554 1.023c-.326 1.176.671 2.248 1.4 3.225 2.705 3.625 2.35 8.649 1.424 13.076z"
          />
          <path
            data-name="Path 43315"
            d="M277.469 140.659a3.17 3.17 0 00.573-1.1 5.585 5.585 0 00-.039-1.453 1.567 1.567 0 00-.541.746 6.453 6.453 0 00.007 1.807z"
          />
          <path
            data-name="Path 43316"
            d="M296.886 170.005a2.345 2.345 0 01-.86.788 2.49 2.49 0 01-1.417.072c-2.179-.326-4.561-1-6.49.055-1.046.567-1.857 1.6-3.02 1.857-1.925.43-3.567-1.417-5.47-1.955a7.638 7.638 0 00-4.128.326 5.7 5.7 0 01-1.079 1.557 8.574 8.574 0 014.594-.446c1.9.528 3.545 2.375 5.473 1.955 1.16-.257 1.974-1.287 3.017-1.857 1.955-1.052 4.31-.391 6.49-.052a2.549 2.549 0 001.417-.072 2.357 2.357 0 00.86-.792 8.756 8.756 0 001.349-2.58 9.461 9.461 0 01-.736 1.144z"
          />
        </g>
      </g>
    </svg>
  );
}

export default SvgLoginWallpaper;
